export const FILTER_ACCESS_CONFIG = {
  contentType: "basic",
  followers: "basic",
  location: "basic",
  gender: "basic",
  price: "basic",

  language: "premium",
  age: "premium",
  ethnicity: "premium",
  verified: "premium",
};

